export default __webpack_public_path__ + "static/media/green-clock.20263cc8.svg";